export const heroData = {
  tags: ['韩漫', '日漫', '国漫', '免费', '全集'],
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '漫画总数', value: '10万+' },
    { label: '注册用户', value: '500万+' },
  ],
};

export const topicsData = [
  { id: 1, name: '韩漫推荐', heat: '98.6万', tag: '热门' },
  { id: 2, name: '日漫连载', heat: '87.3万', tag: '追更' },
  { id: 3, name: '国漫崛起', heat: '76.5万', tag: '新番' },
  { id: 4, name: '恋爱漫画', heat: '65.2万', tag: '甜宠' },
  { id: 5, name: '玄幻修仙', heat: '59.8万', tag: '热血' },
  { id: 6, name: '悬疑推理', heat: '48.1万', tag: '烧脑' },
  { id: 7, name: '搞笑日常', heat: '42.7万', tag: '轻松' },
  { id: 8, name: '都市言情', heat: '38.4万', tag: '人气' },
  { id: 9, name: '穿越重生', heat: '35.9万', tag: '爽文' },
  { id: 10, name: '动作格斗', heat: '31.6万', tag: '打斗' },
  { id: 11, name: '恐怖灵异', heat: '28.3万', tag: '惊悚' },
];

export const cardsData = [
  {
    id: 1,
    title: '我独自升级',
    subtitle: '韩漫天花板·热血战斗',
    desc: '从一个最弱猎人成长为最强战士的逆袭之路，画风炸裂，战斗场面燃到爆！',
    tag: '韩漫',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20manga%20style%20illustration%20of%20a%20powerful%20warrior%20in%20dark%20armor%20with%20glowing%20blue%20energy%20surrounded%20by%20shadow%20creatures%2C%20dramatic%20lighting%2C%20intense%20action%20pose%2C%20warm%20orange%20and%20dark%20contrast%20tones%2C%20cinematic%20composition%2C%20high%20detail%20digital%20art&width=800&height=600&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '女神降临',
    subtitle: '韩漫人气·恋爱甜宠',
    desc: '化妆逆袭的女主角在校园里展开的甜蜜恋爱故事，颜值爆表，少女心炸裂！',
    tag: '韩漫',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20illustration%20of%20a%20stylish%20young%20woman%20with%20long%20flowing%20hair%20in%20a%20cherry%20blossom%20campus%20setting%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20spring%20lighting%2C%20shojo%20manga%20aesthetic%2C%20dreamy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=800&height=600&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '鬼灭之刃',
    subtitle: '日漫神作·少年热血',
    desc: '少年灶门炭治郎为了拯救变成鬼的妹妹，踏上斩鬼之旅，感动亿万读者的史诗之作！',
    tag: '日漫',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20illustration%20of%20a%20young%20swordsman%20with%20a%20nichirin%20blade%20in%20a%20traditional%20Japanese%20village%20at%20night%2C%20flowing%20water%20breathing%20effects%2C%20warm%20amber%20and%20deep%20blue%20contrast%2C%20dramatic%20composition%2C%20highly%20detailed%20anime%20art&width=800&height=600&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '一人之下',
    subtitle: '国漫之光·异人江湖',
    desc: '隐藏在都市中的异人世界，道家文化、奇门遁甲，中国风异能战斗的巅峰之作！',
    tag: '国漫',
    image: 'https://readdy.ai/api/search-image?query=A%20visually%20striking%20Chinese%20manhua%20style%20illustration%20of%20a%20martial%20artist%20in%20traditional%20Taoist%20robes%20surrounded%20by%20mystical%20energy%20and%20ancient%20symbols%2C%20urban%20nighttime%20cityscape%20background%2C%20warm%20golden%20and%20crimson%20tones%2C%20dynamic%20composition%20with%20flowing%20fabric%2C%20high%20detail&width=800&height=600&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '咒术回战',
    subtitle: '日漫热门·咒术对决',
    desc: '高中生虎杖悠仁吞下宿傩手指后，卷入咒术师与诅咒之间的残酷战斗，剧情炸裂！',
    tag: '日漫',
    image: 'https://readdy.ai/api/search-image?query=An%20intense%20manga%20style%20illustration%20of%20a%20young%20sorcerer%20with%20dark%20spiky%20hair%20casting%20a%20powerful%20curse%20technique%20with%20purple%20and%20black%20energy%20swirling%2C%20urban%20Tokyo%20night%20backdrop%2C%20warm%20orange%20accents%20against%20dark%20tones%2C%20cinematic%20lighting%2C%20high%20detail%20digital%20art&width=800&height=600&seq=card-05&orientation=landscape',
  },
];

export const appData = {
  title: '丫丫漫画 APP',
  subtitle: '随时随地，畅享下拉式阅读',
  desc: '专为漫画爱好者打造的移动阅读应用，支持下拉式翻页、离线缓存、智能推荐，海量韩漫日漫国漫随心看。',
  features: ['下拉式翻页阅读', '离线缓存随时随地看', '智能推荐发现好漫', '高清画质流畅体验'],
};

export const contactData = {
  title: '投稿与合作',
  subtitle: '欢迎漫画作者、汉化组与我们联系',
  desc: '丫丫漫画致力于为读者提供最优质的漫画内容。如果您是漫画创作者、汉化组或版权方，欢迎通过以下方式与我们取得联系，共同打造更好的漫画阅读平台。',
  email: 'contact@yaya-comic.com',
};

export const featuresData = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式翻页',
    desc: '独创的下拉式翻页阅读模式，告别传统翻页的繁琐操作，只需向下滑动即可连续阅读，沉浸感十足，阅读效率提升200%。',
  },
  {
    id: 2,
    icon: 'ri-global-line',
    title: '三语漫画全覆盖',
    desc: '韩漫、日漫、国漫三大品类应有尽有，涵盖恋爱、热血、悬疑、搞笑等全部题材，满足不同读者群体的多样化口味需求。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '完全免费阅读',
    desc: '全部漫画资源免费开放，无需付费订阅即可畅享全集阅读。我们通过广告合作维持平台运营，让每一位读者都能无门槛享受漫画乐趣。',
  },
  {
    id: 4,
    icon: 'ri-speed-up-line',
    title: '极速加载体验',
    desc: '采用先进的图片压缩与CDN加速技术，确保每一页漫画都能秒速加载。即使在弱网环境下也能流畅阅读，不会出现卡顿等待。',
  },
  {
    id: 5,
    icon: 'ri-notification-3-line',
    title: '智能追更提醒',
    desc: '订阅喜欢的漫画后，系统会在更新第一时间推送通知，不错过任何一话的精彩内容。自定义更新频率，追更节奏由你掌控。',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '2024年度韩漫TOP10',
    desc: '由百万读者票选出的年度最佳韩漫榜单，从恋爱甜宠到热血战斗，每一部都值得反复品味。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20collage%20style%20illustration%20featuring%20multiple%20Korean%20manhwa%20characters%20in%20dramatic%20poses%2C%20warm%20golden%20and%20rose%20color%20palette%2C%20premium%20editorial%20design%20feel%2C%20clean%20composition%20with%20soft%20gradients%2C%20luxurious%20aesthetic%2C%20no%20text%2C%20high%20detail&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '日漫经典永不过时',
    desc: '从《龙珠》到《鬼灭之刃》，横跨四十年的日漫经典之作，每一部都是时代的烙印与青春的回忆。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20collage%20of%20classic%20Japanese%20manga%20style%20characters%20from%20different%20eras%2C%20nostalgic%20warm%20sepia%20and%20amber%20tones%2C%20vintage%20editorial%20magazine%20layout%20feel%2C%20layered%20composition%2C%20soft%20artistic%20blur%20edges%2C%20high%20quality%2C%20no%20text&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫新番抢先看',
    desc: '国产漫画正在迎来黄金时代，《一人之下》《狐妖小红娘》等现象级作品引领国漫潮流，更多精彩等你发现。',
    tag: '新番推荐',
    image: 'https://readdy.ai/api/search-image?query=An%20artistic%20illustration%20blending%20traditional%20Chinese%20ink%20painting%20style%20with%20modern%20manhua%20aesthetics%2C%20flowing%20ink%20and%20vibrant%20coral%20accents%2C%20elegant%20editorial%20design%2C%20warm%20cream%20background%2C%20layered%20visual%20depth%2C%20high%20quality%2C%20no%20text&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '恋爱漫画甜到齁',
    desc: '从校园纯爱到职场恋爱，精选全网最甜的恋爱漫画合集，每一部都能让你的少女心爆棚。',
    tag: '主题合集',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20and%20dreamy%20illustration%20in%20soft%20pastel%20warm%20tones%2C%20silhouettes%20of%20a%20couple%20under%20cherry%20blossoms%2C%20editorial%20magazine%20style%2C%20gentle%20gradients%20of%20peach%20and%20cream%2C%20elegant%20composition%2C%20high%20quality%2C%20no%20text&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '热血战斗漫燃爆夏日',
    desc: '精选全网最燃热血战斗漫画，从超能力对决到武侠江湖，每一场战斗都让你肾上腺素飙升！',
    tag: '主题合集',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20and%20intense%20illustration%20with%20fiery%20orange%20and%20crimson%20energy%20effects%2C%20action%20silhouettes%20in%20combat%20poses%2C%20bold%20editorial%20design%20feel%2C%20dramatic%20warm%20lighting%2C%20clean%20modern%20composition%2C%20high%20quality%2C%20no%20text&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const updatesData = [
  { id: 1, date: '2026-07-28', title: '《我独自升级》第179话更新', tag: '最新', desc: '暗影君王终于觉醒全部力量，与最强魔王的最终决战一触即发！' },
  { id: 2, date: '2026-07-28', title: '《女神降临》番外篇上线', tag: '番外', desc: '婚后甜蜜日常番外，来看修浩和珠静的婚后幸福生活！' },
  { id: 3, date: '2026-07-27', title: '《咒术回战》第268话更新', tag: '热更', desc: '五条悟与宿傩的领域展开对决进入白热化阶段，胜负即将揭晓。' },
  { id: 4, date: '2026-07-27', title: '新作《仙帝归来》今日上架', tag: '新作', desc: '昔日仙帝重生都市，扮猪吃虎逆天改命，爽感拉满的国漫新作！' },
  { id: 5, date: '2026-07-26', title: '《一人之下》第600话里程碑', tag: '里程碑', desc: '恭喜《一人之下》突破600话大关！官方推出限定纪念活动。' },
  { id: 6, date: '2026-07-26', title: '《鬼灭之刃》全集优化完成', tag: '优化', desc: '全205话高清重制版已上线，画质全面提升，重温经典的最佳时机！' },
  { id: 7, date: '2026-07-25', title: '暑期阅读挑战赛开启', tag: '活动', desc: '完成阅读任务赢取限定头像框和周边好礼，快来参与吧！' },
  { id: 8, date: '2026-07-25', title: '平台新增夜间阅读模式', tag: '功能', desc: '深色主题上线，夜间阅读更护眼，可在设置中自由切换。' },
  { id: 9, date: '2026-07-24', title: '《全知读者视角》第三季预告', tag: '预告', desc: '备受期待的第三季即将回归，独子大人的故事还在继续！' },
];

export const indexData = [
  { id: 1, letter: 'A', title: '爱情与浪漫', count: 1280, desc: '甜到齁的恋爱漫画合集' },
  { id: 2, letter: 'B', title: '暴爽打斗', count: 960, desc: '拳拳到肉的热血战斗' },
  { id: 3, letter: 'C', title: '穿越重生', count: 850, desc: '换个世界重新开始' },
  { id: 4, letter: 'D', title: '都市生活', count: 1100, desc: '现代都市里的精彩故事' },
  { id: 5, letter: 'E', title: '恶魔与超自然', count: 720, desc: '神秘力量与灵异事件' },
  { id: 6, letter: 'F', title: '废柴逆袭', count: 680, desc: '从底层爬上巅峰的爽文' },
  { id: 7, letter: 'G', title: '搞笑日常', count: 950, desc: '轻松幽默的解压神作' },
  { id: 8, letter: 'H', title: '玄幻修仙', count: 1500, desc: '御剑飞行问道长生' },
];

export const aboutData = {
  title: '关于丫丫漫画',
  paragraphs: [
    '丫丫漫画成立于2019年，是一个专注于提供优质漫画阅读体验的在线平台。我们秉持"让每一个人都能轻松享受漫画乐趣"的理念，汇聚了来自韩国、日本和中国的海量漫画资源，涵盖恋爱、热血、悬疑、搞笑、玄幻等全品类题材，满足不同读者的多样化需求。',
    '平台独创的下拉式翻页阅读模式，让漫画阅读变得更加流畅自然——只需向下滑动，即可无缝衔接下一页内容，彻底告别传统翻页的繁琐操作。同时，我们采用先进的图片压缩与CDN加速技术，确保在任意网络环境下都能享受秒速加载的阅读体验。',
    '截至目前，丫丫漫画已收录超过十万部漫画作品，每日更新超过两百话，累计服务超过五百万注册用户。我们持续与国内外优秀的漫画创作者和汉化组保持紧密合作，致力于打造国内最全面、最流畅的漫画在线阅读平台。',
  ],
};

export const commentsData = [
  {
    id: 1,
    name: '小猫咪爱吃鱼',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20cartoon%20avatar%20of%20a%20girl%20with%20cat%20ears%2C%20warm%20peach%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20kawaii%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2026-07-28',
    content: '丫丫漫画的下拉式翻页真的太爽了！之前用别的平台翻页翻到手酸，现在只要一直往下滑就行，一口气看了五十话停不下来。画质也很清晰，加载速度比我用过的其他平台都快很多！',
    rating: 5,
  },
  {
    id: 2,
    name: '追漫小达人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cartoon%20avatar%20of%20a%20boy%20with%20glasses%2C%20warm%20orange%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20cute%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2026-07-27',
    content: '韩漫日漫国漫一应俱全，终于不用在好几个APP之间来回切换了。最近在追《我独自升级》，更新速度很快，翻译质量也很高，强烈推荐！',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜读书人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cartoon%20avatar%20of%20a%20person%20with%20a%20book%2C%20warm%20coral%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20cozy%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2026-07-26',
    content: '新出的夜间模式太贴心了，晚上躲在被窝里看漫画眼睛也不会酸。免费就能看全集这点真的良心，推荐给了身边所有喜欢看漫画的朋友！',
    rating: 4,
  },
  {
    id: 4,
    name: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cartoon%20avatar%20of%20a%20stylish%20person%2C%20warm%20amber%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20cool%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    date: '2026-07-25',
    content: '作为看了十几年漫画的老读者，丫丫漫画的收藏量真的让我惊喜。很多小众好漫画在其他平台找不到，这里都有！更新也特别及时，追更体验一流。',
    rating: 5,
  },
  {
    id: 5,
    name: '甜甜圈少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cartoon%20avatar%20of%20a%20girl%20with%20pink%20hair%2C%20warm%20peach%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20sweet%20style&width=100&height=100&seq=avatar-05&orientation=squarish',
    date: '2026-07-24',
    content: '恋爱漫画真的太好看了！《女神降临》追了三年，每次更新都第一时间来看。分类索引也做得很好，很容易就能找到自己喜欢的类型，推荐给所有少女心爆棚的姐妹！',
    rating: 5,
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '我独自升级', tag: '韩漫', heat: '1580万', trend: 'up' },
  { id: 2, rank: 2, title: '女神降临', tag: '韩漫', heat: '1320万', trend: 'up' },
  { id: 3, rank: 3, title: '鬼灭之刃', tag: '日漫', heat: '1150万', trend: 'stable' },
  { id: 4, rank: 4, title: '一人之下', tag: '国漫', heat: '980万', trend: 'up' },
  { id: 5, rank: 5, title: '咒术回战', tag: '日漫', heat: '860万', trend: 'down' },
];

export const mediaData = [
  {
    id: 1,
    title: '《我独自升级》动画PV首发',
    desc: '期待已久的动画化正式官宣，PV画面惊艳！',
    tag: '动画资讯',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20animation%20style%20key%20visual%20of%20a%20dark%20fantasy%20warrior%20in%20shadow%20armor%20with%20glowing%20purple%20energy%2C%20epic%20atmosphere%2C%20movie%20poster%20quality%2C%20dramatic%20warm%20and%20dark%20contrast%20lighting%2C%20professional%20anime%20production%20art%2C%20no%20text&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国漫《深海》幕后制作特辑',
    desc: '揭秘国产动画电影《深海》的粒子水墨技术。',
    tag: '幕后故事',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20underwater%20scene%20in%20Chinese%20ink%20painting%20style%2C%20flowing%20abstract%20ink%20and%20vibrant%20coral%20colors%2C%20dreamy%20deep%20sea%20atmosphere%2C%20cinematic%20quality%2C%20warm%20golden%20light%20rays%20from%20above%2C%20no%20text&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩漫改编剧热潮解读',
    desc: '从《梨泰院Class》到《女神降临》，韩漫改编为何频频爆款？',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20editorial%20illustration%20showing%20a%20split%20composition%20of%20manhwa%20comic%20panels%20and%20live%20action%20drama%20scenes%2C%20warm%20golden%20and%20cream%20tones%2C%20magazine%20feature%20quality%2C%20modern%20Korean%20aesthetic%2C%20no%20text&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '日漫《蓝色时期》艺术解析',
    desc: '深度解读这部以美术为题材的独特日漫作品。',
    tag: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=An%20artistic%20illustration%20of%20a%20painter%20in%20a%20studio%20with%20colorful%20paint%20strokes%2C%20warm%20natural%20light%20from%20a%20window%2C%20soft%20cream%20and%20amber%20tones%2C%20art%20academy%20atmosphere%2C%20editorial%20quality%2C%20no%20text&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '国漫崛起：从模仿到引领',
    desc: '中国漫画产业如何走出自己的独特风格之路。',
    tag: '产业分析',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20artistic%20illustration%20blending%20traditional%20Chinese%20art%20elements%20with%20modern%20comic%20style%2C%20flowing%20ink%2C%20warm%20golden%20and%20crimson%20accents%2C%20dragon%20and%20phoenix%20motifs%2C%20editorial%20magazine%20quality%2C%20no%20text&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export const faqData = [
  {
    id: 1,
    question: '丫丫漫画是免费的吗？',
    answer: '是的，丫丫漫画平台上的所有漫画资源均为免费阅读。我们通过广告合作维持平台运营，读者无需支付任何费用即可畅享全集漫画阅读体验。部分漫画可能包含少量广告，但不会影响阅读流畅度。',
  },
  {
    id: 2,
    question: '什么是下拉式翻页阅读？',
    answer: '下拉式翻页是丫丫漫画独创的阅读模式。传统漫画阅读需要左右翻页或点击翻页，而下拉式翻页只需在屏幕上向下滑动，即可连续阅读下一话内容，无需任何点击操作。这种模式更符合移动端的操作习惯，阅读体验更加流畅沉浸。',
  },
  {
    id: 3,
    question: '支持哪些类型的漫画？',
    answer: '丫丫漫画涵盖韩漫、日漫、国漫三大品类，题材包括但不限于恋爱、热血、悬疑推理、搞笑日常、玄幻修仙、都市言情、穿越重生、动作格斗、恐怖灵异等。无论你喜欢什么类型，都能在这里找到心仪的作品。',
  },
  {
    id: 4,
    question: '漫画更新频率是怎样的？',
    answer: '平台每日更新超过200话漫画内容，热门连载作品通常会在官方发布后24小时内同步更新。你可以通过订阅功能关注喜欢的漫画，系统会在更新时第一时间推送提醒，确保你不会错过任何精彩内容。',
  },
  {
    id: 5,
    question: '如何在手机上获得最佳阅读体验？',
    answer: '推荐使用丫丫漫画官方APP（支持iOS和Android），APP针对移动端做了深度优化，支持下拉式翻页、离线缓存、夜间模式、智能推荐等功能。当然，你也可以直接在手机浏览器中访问我们的网站，网页版同样提供出色的响应式阅读体验。',
  },
  {
    id: 6,
    question: '我是漫画作者，如何投稿？',
    answer: '欢迎漫画创作者和汉化组与我们合作！请将您的作品样本或合作意向发送至我们的官方邮箱 contact@yaya-comic.com，我们的内容团队会在3-5个工作日内与您取得联系。我们提供有竞争力的分成方案和专业的推广支持。',
  },
];